export default __webpack_public_path__ + "static/media/loading-img.610fd7da.svg";